import type { ReactNode } from 'react';
import { OnboardForm } from './OnboardForm.js';

interface AdminSectionProps {
  expanded: boolean;
  onSuccess: () => void;
}

/**
 * S-UI-002: Collapsible wrapper around OnboardForm.
 * id="admin-section" is referenced by AdminToggleButton's aria-controls.
 * No heading element inside (per redesign spec).
 * Conditional render preferred over display:none so the DOM is clean when collapsed.
 */
export function AdminSection({ expanded, onSuccess }: AdminSectionProps): ReactNode {
  if (!expanded) return null;

  return (
    <div id="admin-section" className="admin-section" data-testid="admin-section">
      <OnboardForm onSuccess={onSuccess} />
    </div>
  );
}
